import { Environment } from "@octopusdeploy/utilities";
import React from "react";
export const DevOnly: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return <React.Fragment>{Environment.isInDevelopmentMode() && children}</React.Fragment>;
};
DevOnly.displayName = "DevOnly"
export default DevOnly;
